import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDraggable } from '@dnd-kit/core';
import CSSTransition from 'react-transition-group/CSSTransition';
import { Job } from 'graphql-common';
import Typography from '@lib/components/Typography/Typography';
import IconButton from '@lib/components/IconButton/IconButton';
import isDeleteAllJobsAvailable from 'components/JobTracker/utils/isDeleteAllJobsAvailable';
import {
  DEFAULT_STYLE,
  DURATION,
  TRANSITION_STYLE,
} from 'components/JobTracker/constants';
import JobPreview from './JobPreview';
import styles from './JobTracker.module.scss';

export default function DraggableContent({
  dragPosition,
  accordionRef,
  jobs,
  onRemoveJobHandler,
  isAccordionOpen,
  toggleAccordion,
  restart,
  stop,
  onRemoveAllJobIds,
}: {
  dragPosition: { x: number; y: number };
  accordionRef: React.RefObject<HTMLDivElement | null>;
  jobs: Job[];
  onRemoveJobHandler: (jid: string) => void;
  isAccordionOpen: boolean;
  toggleAccordion: () => void;
  restart: () => void;
  stop: () => void;
  onRemoveAllJobIds: () => void;
}) {
  const { t } = useTranslation();
  const nodeRef = React.useRef<HTMLDivElement>(null);
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: 'upload-block',
  });
  return (
    <div
      ref={setNodeRef}
      className={styles.root}
      style={{
        left: transform ? dragPosition.x + transform.x : dragPosition.x,
        top: transform ? dragPosition.y + transform.y : dragPosition.y,
      }}
    >
      <div {...listeners} {...attributes} className={styles.dndPlaceholder} />
      <div ref={accordionRef} className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <Typography variant="h3">{t('process-activity')}</Typography>
          </div>
          <IconButton
            icon="expand_more"
            className={styles.headerBtn}
            onClick={toggleAccordion}
          />
          <IconButton
            icon="close"
            className={styles.headerBtn}
            disabled={!isDeleteAllJobsAvailable(jobs)}
            onClick={onRemoveAllJobIds}
          />
        </div>
        <CSSTransition
          in={isAccordionOpen}
          timeout={DURATION}
          unmountOnExit
          nodeRef={nodeRef}
        >
          {(transitionState) => (
            <div
              style={{
                ...DEFAULT_STYLE,
                ...TRANSITION_STYLE[transitionState],
              }}
            >
              <div className={styles.body}>
                {jobs.map((job) => (
                  <JobPreview
                    key={job.jid}
                    job={job}
                    removeJobId={onRemoveJobHandler}
                    restart={restart}
                    stop={stop}
                  />
                ))}
              </div>
            </div>
          )}
        </CSSTransition>
      </div>
    </div>
  );
}
